import React from 'react';
import { useLanguage, languages } from '../context/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageToggle = () => {
  const { language, setLang } = useLanguage();

  return (
    <div className="language-toggle">
      <Globe size={16} className="language-icon" />
      <select 
        value={language} 
        onChange={(e) => setLang(e.target.value)}
        className="language-select"
        aria-label="Select language"
      >
        {Object.entries(languages).map(([code, name]) => (
          <option key={code} value={code}>
            {name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageToggle;
